import app from 'flarum/forum/app';
import MpProductEmbed from './components/MpProductEmbed';
/**
 * Cache em memória por URL — evita refetch a cada redraw do post.
 * Composer espera < 100 produtos por sessão; um Map simples basta.
 */
const cache = new Map();

/** Padrões de URL que valem a pena testar (evita fetch em qualquer link). */
const PATH_PATTERNS = [/^\/extension\/[a-z][a-z0-9_.-]*\/[a-z][a-z0-9_.-]*\/?$/i, /^\/item\/[a-z0-9-]+\/?$/i, /^\/product\/\d+\/?$/i];
function isProductUrl(url) {
  try {
    const u = new URL(url, location.href);
    if (u.host !== location.host) return false;
    return PATH_PATTERNS.some(re => re.test(u.pathname));
  } catch {
    return false;
  }
}
async function fetchMeta(url) {
  if (cache.has(url)) return cache.get(url);
  const apiBase = app.forum.attribute('apiUrl') || '/api';
  const endpoint = apiBase.replace(/\/$/, '') + '/marketplace/oembed?url=' + encodeURIComponent(url);
  try {
    const resp = await fetch(endpoint, {
      credentials: 'include'
    });
    if (!resp.ok) {
      cache.set(url, {
        found: false
      });
      return cache.get(url);
    }
    const data = await resp.json();
    cache.set(url, data);
    return data;
  } catch {
    cache.set(url, {
      found: false
    });
    return cache.get(url);
  }
}

/**
 * Escaneia um container DOM (post body), encontra links de produto do
 * marketplace e renderiza o card embed inline (logo após o link).
 *
 * Idempotente: não re-renderiza se já tem `data-mp-embedded` na âncora.
 * Não modifica o link original — apenas adiciona o card abaixo.
 */
export async function scanAndEmbed(container) {
  if (!app.forum.attribute('marketplace_embed_enabled')) return;
  const links = container.querySelectorAll('a[href]');
  for (const a of Array.from(links)) {
    if (a.dataset.mpEmbedded) continue;
    const href = a.getAttribute('href');
    if (!href || !isProductUrl(href)) continue;
    a.dataset.mpEmbedded = 'pending';
    const meta = await fetchMeta(href);
    if (!meta?.found) {
      a.dataset.mpEmbedded = 'no';
      continue;
    }

    // Só uma embed por link (evita duplicar em redraws). Insere DEPOIS
    // do link original — não substitui, mantém o texto clicável também.
    const wrapper = document.createElement('div');
    wrapper.className = 'MpEmbed-wrap';
    a.dataset.mpEmbedded = 'yes';

    // Mounta o componente Mithril dentro do wrapper
    m.mount(wrapper, {
      view: () => m(MpProductEmbed, {
        meta
      })
    });

    // Insere logo após o link (parágrafo atual). Se o link estiver
    // sozinho no parágrafo, podemos esconder o link pra evitar duplicar
    // texto (igual Discord/Slack).
    const parent = a.parentElement;
    if (parent && parent.children.length === 1 && parent.textContent?.trim() === a.textContent?.trim()) {
      a.style.display = 'none';
      parent.appendChild(wrapper);
    } else {
      a.insertAdjacentElement('afterend', wrapper);
    }
  }
}